import { Component, effect, inject, signal } from '@angular/core';
import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonItem,
  IonLabel,
  IonList,
  IonMenuButton,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { WorkContactAndProjectsResultDto, WorkSearchCategoryEnum } from '@work-frontend-monorepo/work-rest-api';
import { Router } from '@angular/router';
import {
  GlobalMegasearchResultContactAndProjectsComponent,
  MegasearchResultClickedInterface,
} from '../../../../../../../work-office/src/app/global/components/global-megasearch-result-contact-and-projects/global-megasearch-result-contact-and-projects.component';
import { InputFieldComponent } from '@work-frontend-monorepo/work-ui/forms';
import { MegasearchService } from '@work-frontend-monorepo/work-ui/services';
import { LoadingAndFeedbackState } from '@work-frontend-monorepo/work-ui/utilities';

@Component({
  selector: 'sfg-app-projekte-uebersicht-page',
  templateUrl: './projekte-uebersicht-page.component.html',
  styleUrls: ['./projekte-uebersicht-page.component.scss'],
  standalone: true,
  imports: [
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonMenuButton,
    IonButtons,
    IonBackButton,
    IonList,
    IonItem,
    IonLabel,
    TranslatePipe,
    GlobalMegasearchResultContactAndProjectsComponent,
    InputFieldComponent,
  ],
})
export class ProjekteUebersichtPageComponent {
  private readonly megasearchService = inject(MegasearchService);
  private readonly router = inject(Router);

  // Signals
  searchTerm = signal<string>('');
  searchLoadingState = signal<LoadingAndFeedbackState>('none');
  searchResults = signal<WorkContactAndProjectsResultDto[]>([]);

  // Effect: Führt Suche aus, wenn sich der Suchbegriff ändert
  private readonly searchEffect = effect(async () => {
    const term = this.searchTerm();

    if (!term || term.trim().length < 2) {
      this.searchResults.set([]);
      return;
    }

    this.searchLoadingState.set('loading');

    try {
      const result = await this.megasearchService.doSearch(term.trim(), [WorkSearchCategoryEnum.ContactAndProjects], undefined);

      this.searchResults.set(result.contactAndProjects || []);
    } catch (error) {
      console.error('Fehler beim Suchen von Projekten:', error);
      this.searchResults.set([]);
    } finally {
      this.searchLoadingState.set('none');
    }
  });

  onSearchChange(searchTerm: string): void {
    this.searchTerm.set(searchTerm);
  }

  async onProjectClick(result: MegasearchResultClickedInterface) {
    await this.router.navigate(['/mitarbeitende/projekte/details', result.selectedProject?.id], {
      queryParams: { ignoreErstinstruktion: true },
    });
  }
}
